import { useEffect, useState } from "react";

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
}

export const useWindowDimensions = (props) => {
    const [windowDimensions, setWindowDimensions] = useState( getWindowDimensions() ); 

    const handleResize = () => {
        setWindowDimensions(getWindowDimensions());
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    });
    
    return windowDimensions;

}